import Vue from "vue";
import Component from "vue-class-component";

@Component({ name: "MagazineFilterBox" })
export default class MagazineFilterBox extends Vue {
    public selectedNewsCategorySlug: string = (<any>window).App.bag.SelectedNewsCategorySlug;

    get routes() {
        return (<any>window).App.routes;
    }

    get newsCategories() {
        return (<any>window).App.bag.Categories;
    }

    public setNewsCategory(newsCategorySlug: string) {
        if (newsCategorySlug != "") {
            window.location.href = this.routes.Magazine_List + "/" + newsCategorySlug;
        } else {
            window.location.href = this.routes.Magazine_List;
        }
    }

    public setNewsCategorySelected(newsCategorySlug: string) {
        if (this.selectedNewsCategorySlug === newsCategorySlug) {
            return true
        } else {
            return false;
        }
    }

    public setAllButtonSelected(newsCategorySlug: string) {
        if (newsCategorySlug === "") {
            return true;
        } else {
            return false;
        }
    }
};